// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/components/sidenav/styles/MenuBar.scss
// module id = 1230
// module chunks = 0